/*
 * Modemagic overlay repair (Lamp Boy).
 * The Modemagic app embed (#md-app-embed__modal) intermittently leaves its
 * full-viewport overlay mounted and interactive (pointer-events:auto) while it is
 * effectively invisible (opacity ~0 somewhere up its own chain), which silently
 * swallows every click on the page — including the desktop sticky Add to cart and
 * the main Add to cart. This makes any large, effectively-invisible element inside
 * the modal click-through, and leaves it fully interactive when a popup is
 * genuinely shown (visible + non-zero size). Self-contained, guarded writes.
 */
(function () {
  var ROOT_SEL = '#md-app-embed__modal';

  // Product of this element's opacity and every ancestor's opacity. Also reports
  // whether anything in the chain is display:none / visibility:hidden (=> not painted).
  function effectiveVisibility(el) {
    var opacity = 1;
    var painted = true;
    var node = el;
    while (node && node.nodeType === 1) {
      var cs = window.getComputedStyle(node);
      if (cs.display === 'none' || cs.visibility === 'hidden') painted = false;
      var o = parseFloat(cs.opacity);
      if (!isNaN(o)) opacity *= o;
      node = node.parentElement;
    }
    return { opacity: opacity, painted: painted };
  }

  function isLarge(el) {
    var r = el.getBoundingClientRect();
    var vw = window.innerWidth || document.documentElement.clientWidth;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return r.width * r.height > vw * vh * 0.25; // covers >25% of the viewport
  }

  function setPE(el, val) {
    // guarded write: only touch the DOM when the value actually changes
    var current = el.style.getPropertyValue('pointer-events');
    var currentPri = el.style.getPropertyPriority('pointer-events');
    if (val === null) {
      if (current !== '') el.style.removeProperty('pointer-events');
    } else if (current !== val || currentPri !== 'important') {
      el.style.setProperty('pointer-events', val, 'important');
    }
  }

  function apply(root) {
    if (!root) return;
    // Consider the modal root and every descendant: neutralise any large element
    // that is present but effectively invisible; restore everything else.
    var nodes = [root];
    var all = root.querySelectorAll('*');
    for (var k = 0; k < all.length; k++) nodes.push(all[k]);

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var vis = effectiveVisibility(el);
      var large = isLarge(el);
      var stuck = large && (!vis.painted || vis.opacity < 0.01);
      if (stuck) {
        setPE(el, 'none');   // invisible but blocking -> let clicks pass through
      } else {
        setPE(el, null);     // visible popup, or harmless -> leave interactive
      }
    }
  }

  function schedule(root) {
    // re-check across the popup's open/close transition ramp
    apply(root);
    clearTimeout(root.__mdT1); root.__mdT1 = setTimeout(function () { apply(root); }, 80);
    clearTimeout(root.__mdT2); root.__mdT2 = setTimeout(function () { apply(root); }, 260);
    clearTimeout(root.__mdT3); root.__mdT3 = setTimeout(function () { apply(root); }, 520);
  }

  function attach(root) {
    apply(root);
    var mo = new MutationObserver(function () { schedule(root); });
    mo.observe(root, {
      attributes: true,
      attributeFilter: ['style', 'class', 'aria-hidden', 'hidden'],
      subtree: true,
      childList: true
    });
    // opacity animations don't fire mutations per frame; re-check on interaction too
    window.addEventListener('resize', function () { schedule(root); }, { passive: true });
  }

  function boot() {
    var root = document.querySelector(ROOT_SEL);
    if (root) { attach(root); return; }
    // the app embed injects the modal asynchronously — wait for it
    var bodyMo = new MutationObserver(function () {
      var r = document.querySelector(ROOT_SEL);
      if (r) { bodyMo.disconnect(); attach(r); }
    });
    bodyMo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { bodyMo.disconnect(); }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
